import { HTMLAttributes } from 'react'
import cl from 'classnames'

const InfoCardLabel = ({
  className,
  ...rest
}: HTMLAttributes<HTMLSpanElement>) => {
  return (
    <span
      className={cl(
        'text-[0.5rem] leading-none text-v3-gray-475 tracking-wide uppercase lg:text-xs lg:leading-none xl:text-[0.49575rem] xl:leading-[5.359px] 1.5xl:text-xs 1.5xl:leading-none',
        className
      )}
      {...rest}
    />
  )
}

export const Label = InfoCardLabel
